module.exports = __webpack_public_path__ + "static/media/Pet.c3ec2414.svg";